import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { LEGISLATION_FOLDERS } from 'constants/requests'

export default new Controller({
  name: 'LegacyLegislationMenuRedirect',
  route: ':aol/legislation',
  controller (Router) {
    const target = url(LEGISLATION_FOLDERS)
    replaceUrl(target)
  }
})
